import { render, staticRenderFns } from "./HtmlComponent.vue?vue&type=template&id=6ec23210&scoped=true"
import script from "./HtmlComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HtmlComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HtmlComponent.vue?vue&type=style&index=0&id=6ec23210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec23210",
  null
  
)

export default component.exports